import { render, staticRenderFns } from "./m-product-links.vue?vue&type=template&id=753cdd97&scoped=true&"
import script from "./m-product-links.vue?vue&type=script&lang=js&"
export * from "./m-product-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753cdd97",
  null
  
)

export default component.exports